{
  "game.title": "The Secret of the Bermuda Triangle",
  "boot.milestone": "M0 — foundation in place",
  "common.ok": "All right",
  "common.cancel": "Cancel",
  "common.back": "Back",
  "common.continue": "Continue",
  "common.seed": "Seed: {seed}",
  "outcome.rescue": "Rescue",
  "outcome.salvage": "Salvage",
  "outcome.cold": "Cold trail",
  "outcome.nothing": "Nothing left to find",
  "outcome.rescue.summary": "You reach {noun:life_raft|art=def} in time. {count, plural, one {One person survives} other {# people survive}}.",
  "outcome.salvage.summary": "You are too late for the crew. At least you recover {noun:hull_fragment|art=indef}.",
  "outcome.cold.summary": "Little remains {noun:wreck|art=def|prep=of} — only {noun:debris_field|art=indef} still drifting here.",
  "outcome.nothing.summary": "The sea is empty. No oil, no debris, nothing.",
  "clue.found": "You recover {noun:clue|art=def}.",
  "clue.found.count": "{count, plural, =0 {No clues} one {# clue} other {# clues}} secured.",
  "clue.ledger.title": "Evidence",
  "mission.distress.received": "{noun:distress_call|art=indef|caps} from {vessel}.",
  "mission.eta": "Estimated arrival in {hours} hours.",
  "mission.depth": "Depth below the keel: {meters} metres.",
  "voyage.fuel": "Fuel",
  "voyage.hull": "Hull integrity",
  "voyage.speed": "Speed: {knots} knots",
  "voyage.weather.calm": "Calm seas.",
  "voyage.weather.rough": "Heavy seas. {noun:storm|art=indef|caps} is closing in.",
  "background.pilot": "Military pilot",
  "background.naval_officer": "Naval officer",
  "background.marine_biologist": "Marine biologist",
  "accusation.prompt": "What is behind all this?",
  "accusation.confidence": "Supported by {count, plural, one {# piece of evidence} other {# pieces of evidence}}.",
  "preload.loading": "Loading chart …",
  "preload.failed": "The chart could not be loaded.",
  "place.base": "Thalassa Station",
  "place.trench": "Milwaukee Deep",
  "place.tongue": "Tongue of the Ocean",
  "place.sargasso": "Sargasso Sea",
  "place.seamount": "Bermuda Seamount",
  "base.title": "Thalassa Station",
  "base.subtitle": "North edge of the Northwest Providence Channel · 26°10.2'N 077°36.0'W",
  "base.standby": "The radio is silent. For now.",
  "base.depart": "Put to sea",
  "map.return": "Return to station",
  "map.hint": "Click to set a course.",
  "map.hud.position": "Position",
  "map.hud.depth": "Depth below keel",
  "map.hud.depth.aground": "aground",
  "map.hud.speed": "Speed",
  "map.hud.nearest": "Nearest point",
  "map.hud.remaining": "Distance to run",
  "map.hud.sea": "Sea",
  "map.hud.zoom": "View",
  "map.hud.knots": "{knots} kn",
  "map.hud.metres": "{metres} m",
  "map.hud.distance": "{miles} nm",
  "map.zoom.strategic": "Overview",
  "map.zoom.transit": "Transit",
  "map.zoom.tactical": "Close range",
  "vessel.ship": "Research vessel Thalassa",
  "vessel.submarine": "Submersible Nyx",
  "incident.cargo_vessel": "Cargo vessel",
  "incident.fishing_boat": "Fishing vessel",
  "incident.private_yacht": "Sailing yacht",
  "incident.airliner": "Airliner",
  "incident.light_aircraft": "Light aircraft",
  "incident.naval_patrol": "Coast guard cutter",
  "weather.calm": "Calm seas",
  "weather.moderate": "Moderate seas",
  "weather.rough": "Rough seas",
  "weather.heavy": "Heavy seas",
  "weather.storm": "Storm",
  "base.calls.none": "No open distress calls. The sea is quiet.",
  "base.calls.title": "Open distress calls",
  "base.clock": "Day {day}, {hour}:00",
  "base.reputation": "Standing: {value}",
  "base.act": "Act {act}",
  "base.evidence": "Evidence ({count})",
  "base.wait": "Wait (12 h)",
  "base.finale": "Close the report",
  "base.progress": "{collected} of {total} clues",
  "call.age": "{hours} h ago",
  "call.distance": "{miles} nm",
  "call.souls": "{count, plural, one {# person} other {# people}} aboard",
  "call.depth": "Bottom at {metres} m",
  "briefing.title": "Mission planning",
  "briefing.vessel": "Vessel",
  "briefing.speed": "Speed",
  "briefing.speed.slow": "Slow ahead",
  "briefing.speed.cruise": "Cruising speed",
  "briefing.speed.full": "Full ahead",
  "briefing.eta": "Arrival in {hours} h",
  "briefing.fuel": "Fuel {used} of {available}",
  "briefing.hull": "Hull damage {value} %",
  "briefing.sea": "Worst seas en route: {sea}",
  "briefing.forecast": "Expected on arrival",
  "briefing.fuel.short": "There is not enough fuel for the return leg.",
  "briefing.depth.warning": "The bottom lies deeper than this vessel can work.",
  "briefing.depth.short": "too deep",
  "briefing.shallow.warning": "The direct course crosses a bank with only {metres} m of water.",
  "briefing.landfall.warning": "The direct course crosses land. A detour will be needed.",
  "briefing.depart": "Cast off",
  "briefing.cancel": "Back",
  "site.title": "On site",
  "site.arrived": "Arrived after {hours} hours.",
  "site.rescued": "{count, plural, one {# survivor recovered} other {# survivors recovered}}.",
  "site.lost": "{count, plural, one {# person} other {# people}} not found.",
  "site.evidence.title": "Secured",
  "site.evidence.none": "Nothing that could be secured.",
  "site.depth.blocked": "The wreck lies too deep. The sonar leaves only a shadow.",
  "evidence.title": "Evidence",
  "evidence.empty": "Nothing secured yet.",
  "evidence.act": "Act {act}",
  "evidence.from": "from: {source}",
  "evidence.close": "Close",
  "evidence.outstanding": "Still missing in this act",
  "evidence.hint": "The station does not draw conclusions. That is left to you.",
  "slot.witness_testimony": "Witness testimony",
  "slot.instrument_reading": "Instrument reading",
  "slot.anomaly_signature": "Anomaly",
  "slot.physical_artifact": "Physical artifact",
  "slot.missing_person_trace": "Trace of the missing",
  "slot.third_party_interference": "Third-party presence",
  "finale.title": "Final report",
  "finale.prompt": "What lies behind the disappearances in the Bermuda Triangle?",
  "finale.submit": "Argue this case",
  "finale.correct": "You were right.",
  "finale.wrong": "You were wrong.",
  "finale.truth": "It was in fact: {truth}",
  "finale.supported": "Your findings carried this conclusion.",
  "finale.unsupported": "Your own findings spoke against it.",
  "finale.collected": "{collected} of {total} clues secured.",
  "finale.restart": "New run",
  "briefing.forecast.uncertain": "{tier}, possibly {alternative}",
  "map.hud.forecast.uncertain": "{tier}?",
  "briefing.detour": "Course runs {percent} % longer around shoals — {miles} nm over ground.",
  "menu.sound": "Sound",
  "menu.sound.on": "On",
  "menu.sound.off": "Off",
  "menu.imprint": "Legal notice",
  "imprint.title": "Legal notice & disclosures",
  "imprint.ai.heading": "Use of artificial intelligence",
  "imprint.ai.body": "This game was developed entirely with the assistance of generative AI — program code, texts, game mechanics and sound design were created in collaboration with Claude (Anthropic).\n\nNo AI-generated image or audio files are used: all graphics are drawn at runtime from the program code, and all sound is synthesised in the browser. The clue texts in the game are fiction and describe no actual events, people or vessels.",
  "imprint.privacy.heading": "Privacy",
  "imprint.privacy.body": "The game runs entirely in the browser. No server, no accounts, no cookies. Usage is counted with a self-hosted Matomo — without cookies, with a truncated IP address, and honouring “Do Not Track”. You can opt out at any time under Settings → Audience measurement or in the privacy policy. Local storage holds only the save game, the chosen language, font size, sound setting and your opt-out, if any; none of it leaves the device.",
  "imprint.data.heading": "Chart data",
  "imprint.data.body": "Bathymetry: ETOPO 2022, NOAA National Centers for Environmental Information (public domain). Coastlines: Natural Earth (public domain). The chart is a game object and is not suitable for navigation.",
  "imprint.legal.hint": "Full provider identification and privacy policy: impressum.html",
  "imprint.version": "Version {version}",
  "imprint.close": "Back"
}
